import { AppConfig } from '@core/domain/AppConfig.ts';
import { getEmbeddedEntregaPdfTemplate } from 'embedded-entrega-pdf-template';
import { getEmbeddedReposicionPdfTemplate } from 'embedded-reposicion-pdf-template';
import { loadPdfTemplateBytes, resetPdfTemplateCache } from './loadPdfTemplateBytes.ts';

const entregaCache = { bytes: null as Uint8Array | null };
const reposicionCache = { bytes: null as Uint8Array | null };

export async function loadEntregaPdfTemplateBytes(): Promise<Uint8Array> {
  return loadPdfTemplateBytes(entregaCache, getEmbeddedEntregaPdfTemplate(), AppConfig.getEntregaPdfTemplateUrl(), 'FO-GESR');
}

export function resetEntregaPdfTemplateCacheForTests(): void {
  resetPdfTemplateCache(entregaCache);
}

export async function loadReposicionPdfTemplateBytes(): Promise<Uint8Array> {
  return loadPdfTemplateBytes(
    reposicionCache,
    getEmbeddedReposicionPdfTemplate(),
    AppConfig.getReposicionPdfTemplateUrl(),
    'FO-GESR reposición',
  );
}

export function resetReposicionPdfTemplateCacheForTests(): void {
  resetPdfTemplateCache(reposicionCache);
}
